import { useCallback } from 'react';
import { MarkerIcon } from '@rsos/assets/icons';
import HoveredButton from '@rsos/components/capstone/HoveredButton';
import { trackClickStreetView } from '../helpers/trackings';
import { LeftText, RowBox, IconWrapper } from '../styles/common.styles';

const StreetView = ({
  isHoverable,
  longitude,
  latitude,
  irpVersion,
  payloadID,
  requestID,
  portalType,
  isEsriMap,
}) => {
  // Google map street view parameter
  // q= Query - anything passed in this parameter is treated as if it had been typed into the query box on the maps.google.com page.
  // layer= Activates overlays. Current options are "t" traffic, "c" street view.
  // cbll= Latitude,longitude for Street View
  // cbp= Street View window that accepts 5 parameters: details here https://stackoverflow.com/questions/387942/google-street-view-url
  const onClick = useCallback(() => {
    const streetViewURL = `https://google.com/maps?q=&layer=c&cbll=${latitude},${longitude}&cbp=11,0,0,0,0`;
    window.open(streetViewURL, '_blank', 'noopener noreferrer');
    trackClickStreetView(irpVersion, payloadID, requestID, portalType);
  }, [irpVersion, latitude, longitude, payloadID, portalType, requestID]);

  if (!isEsriMap) return null;

  return (
    <RowBox br="5px" isHoverable={isHoverable}>
      <RowBox>
        <IconWrapper>
          <MarkerIcon
            width={14}
            height={25}
            viewboxWidth={18}
            viewboxHeight={16}
          />
        </IconWrapper>
        <RowBox data-name="esri-streetview">
          <LeftText>Google Street View</LeftText>
        </RowBox>
      </RowBox>
      {isHoverable && (
        <HoveredButton onClick={onClick} withIcon hasExternalLink />
      )}
    </RowBox>
  );
};

export default StreetView;
